// third-party
import { merge } from 'lodash';

// project import
import AppBar from './AppBar';
import Button from './Button';

// ==============================|| OVERRIDES - MAIN ||============================== //

export default function ComponentsOverrides(theme) {
    return merge(
        AppBar(theme),
        Button(theme)
    );
}
